import { Header } from '../components/Header';
import { PageMetadata } from '../components/PageMetadata';
import { Footer } from '../components/Footer/Footer';
import Copy from '../copy/privacy-policy.md';

export default function Privacy() {
  return (
    <>
      <PageMetadata
        pageTitle="Privacy Policy"
        description="Discover HealthPlans of NC privacy policy to understand how we use your details and who we share your information with."
      />
      <Header />
      <div className="w-full px-4 py-8 bg-gray-200">
        <div className="container p-6 mx-auto shadow rounded bg-white">
          <Copy />
        </div>
      </div>
      <Footer />
    </>
  );
}
